import React from 'react'
import { Link } from "react-router-dom";


const HomeBanner = () => {
    return (
        <>
            <div className="hero dark-section">
                <div className="container">
                    <div className="row align-items-center" style={{ marginTop: "-120px" }}>
                        <div className="col-lg-6">
                            {/* Hero Content Start */}
                            <div className="hero-content">
                                {/* Section Title Start */}
                                <div className="section-title">
                                    <h3 className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}><b>Pure Mahua. Pure Strength. Pure Wellness.</b></h3>
                                    <h1 className="text-anime-style-3" data-cursor="-opaque" style={{ perspective: 400 }}>
                                        <div className="split-line" style={{ display: 'block', textAlign: 'start', position: 'relative' }}>
                                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                               {/* Mahua Shakti Blend Nature’s Power in Every Spoon */}
                                               Nature's Power Is Almost Here
                                            </div>
                                        </div>
                                    </h1>
                                    {/* <p className="wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>Whether it's everyday essentials or something a little special our products are made to bring families together - through trust, taste, and thoughtfully prepared food.</p> */}
                                </div>
                                {/* Section Title End */}
                                {/* Hero Body Start */}
                                <div className="hero-body wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                    <div className="hero-btn">
                                        <Link to="https://wa.me/+916262556132" className="btn-default btn-highlighted">Buy Now</Link>
                                    </div>
                                    <div className="hero-btn">
                                        <Link target="_blank" to="https://www.indiapost.gov.in/" className="btn-default btn-highlighted">Track Order</Link>
                                    </div>
                                </div>
                                {/* Hero Body End */}

                                {/* Review Box Start */}
                            </div>
                            {/* Hero Content End */}
                        </div>
                        <div className="col-lg-6">
                            {/* Hero-Image Start */}
                            <div className="hero-image wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                <figure>
                                    <img src="assets/img/ChatGPTI.webp" alt />
                                </figure>
                            </div>
                            {/* Hero-Image End */}
                        </div>
                    </div>
                </div>
            </div>

            <div className="our-scrolling-ticker">
                {/* Scrolling Ticker Start */}
                <div className="scrolling-ticker-box">
                    <div className="scrolling-content">
                        <span><img src="assets/images/icon-sparkle-white.svg" alt />Fuel Your Day with Mahua Shakti Blend</span>
                        <span><img src="assets/images/icon-sparkle-white.svg" alt />Everyday Nourishment</span>
                        <span><img src="assets/images/icon-sparkle-white.svg" alt />Mahua Shakti Blend – Strength • Energy • Wellness</span>
                    </div>
                    <div className="scrolling-content">
                        <span><img src="assets/images/icon-sparkle-white.svg" alt />Flavors You Love</span>
                        {/* <span><img src="assets/images/icon-sparkle-white.svg" alt />Naturally Delicious</span> */}
                        <span><img src="assets/images/icon-sparkle-white.svg" alt />Strength Rooted in Tradition</span>
                        <span><img src="assets/images/icon-sparkle-white.svg" alt />Mahua Shakti Blend – Strength • Energy • Wellness</span>
                    </div>
                </div>
            </div>




        </>
    )
}

export default HomeBanner